import React,{  useState } from "react";
import Modal from "react-bootstrap/Modal";
import Eventos from "./Eventos";
import AddCircle from "../../assets/svg/addCircle";

const AddEventButton = ({children, setUpdateEventList}) =>{
  
  const handleClose = () => setShow(false);

  const [show, setShow] = useState(false);
  return (
    <>

      <AddCircle onClick={(e) => setShow(true)} />

      <Modal
        show={show}
        keyboard={false}
        dialogClassName="kr-modal"
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="form form--white ">
              <Eventos setShow={setShow} setUpdateEventList={setUpdateEventList}></Eventos>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default AddEventButton;